import { IUser } from "src/types/common";

export const getFullNameOrNickName = (user: Pick<IUser, "firstName" | "lastName" | "nickName">) => getFullName(user) ?? user.nickName;

export const getFullName = (user: Pick<IUser, "firstName" | "lastName">) =>
    user.firstName && user.lastName ? `${user.firstName} ${user.lastName}` : null;
